<template>
	<div>
		<b-container fluid>
			<b-form @submit="onSubmit">

				<input type="hidden" id="dataItem-id-hidden" v-model="dataItem.id" />
<b-form-group label="envelopeId">
      <b-form-input
          type="text"
          id="dataItem-envelopeId-input"
          class="form-input"
          v-model="dataItem.envelopeId"
          @blur="$v.dataItem.envelopeId.$touch()"
      ></b-form-input>
      <div class="invalid-feedback">
          <div v-if="!$v.dataItem.envelopeId.required">envelopeId is required</div>
      </div>
      </b-form-group>
<b-form-group label="status">
      <b-form-input
          type="text"
          id="dataItem-status-input"
          class="form-input"
          v-model="dataItem.status"
          @blur="$v.dataItem.status.$touch()"
      ></b-form-input>
      <div class="invalid-feedback">
          <div v-if="!$v.dataItem.status.required">status is required</div>
      </div>
      </b-form-group>
<b-form-group label="statusDateTime">
      <b-form-input
          type="text"
          id="dataItem-statusDateTime-input"
          class="form-input"
          v-model="dataItem.statusDateTime"
          @blur="$v.dataItem.statusDateTime.$touch()"
      ></b-form-input>
      <div class="invalid-feedback">
          <div v-if="!$v.dataItem.statusDateTime.required">statusDateTime is required</div>
      </div>
      </b-form-group>
<b-form-group label="uri">
      <b-form-input
          type="text"
          id="dataItem-uri-input"
          class="form-input"
          v-model="dataItem.uri"
          @blur="$v.dataItem.uri.$touch()"
      ></b-form-input>
      <div class="invalid-feedback">
          <div v-if="!$v.dataItem.uri.required">uri is required</div>
      </div>
      </b-form-group>
<b-form-group label="active">
  <b-form-checkbox
    id="dataItem-active-input"
    class="form-input"
    v-model="dataItem.active">active
    </b-form-checkbox>
  </b-form-group>


				<b-row>
					<b-col md="6">
						<label>Created</label>
					</b-col>
					<b-col md="6">
						<label>Modified</label>
					</b-col>
				</b-row>

				<b-button
					type="submit"
					variant="primary"
					style="margin: 5px;"
				>Save</b-button>
				<b-button
					style="margin: 5px;"
					@click="cancel"
				>Cancel</b-button>
			</b-form>
		</b-container>

	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import service from '../../service';
import { dataItemDto, dataItem } from '../../dto';

export default {
  name: 'Addaes_envelopestat',
  components: {

  },
  data: () => ({
    dataItem: dataItem,

  }),
  methods:{
    async onSubmit(e) {
      e.preventDefault();

      this.$v.dataItem.$touch();
      if (this.$v.dataItem.$invalid) {
        return;
      }

      let payload = new dataItemDto(this.dataItem);
      payload.id = 0; //New records will start with an id of zero
      payload.active = true; //New records will always be true

      try {
        const id = await service.create(payload);
        this.redirectToListing();
      } catch {}
    },
    cancel(){
      this.redirectToListing();
    },
    redirectToListing() {
      this.$router.push({ name: 'aes_envelopestats' });
    }
  },
  validations: {
    dataItem: {

      id:{
      },
      envelopeId:{
      },
      status:{
      },
      statusDateTime:{
      },
      uri:{
      },
      dateCreated:{
      },
      dateModified:{
      },
      createdByUserId:{
      },
      modifiedByUserId:{
      },
      active:{
      },
    }
  }
};
</script>
